import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartPlus, faUser, faBars, faTimes, faMapMarkerAlt ,faShoppingCart} from '@fortawesome/free-solid-svg-icons';
import selsmartLogo from '../../../assets/images/selsmart.png'
import { useExchangeUser } from '../../../contexts/userExchangeProgramContext';
// import { useCart } from '../../contexts/cartContext';
import searchbarImage from '../../assets/images/search.svg';
import { Link } from 'react-router-dom';
import './exchangeCommon.css';

interface CityPopupProps {
    onClose: () => void;
    onFetchLocation: () => void;
    onCitySelected: (cityName: string) => void; // Callback to update city in Header
    setIsLoading: (loading: boolean) => void;
}

interface Product {
    // product_id: Key | null | undefined;
    title: string;
    cat_id: number;
}


const Header: React.FC = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    // const { cartQuantity, setCartQuantity } = useCart();
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const location = useLocation();
    const { setcityName } = useExchangeUser();
    const navigate = useNavigate();
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    const google_api_key = process.env.GOOGLE_API_KEY
    const suggestionsRef = useRef<HTMLUListElement | null>(null);
 

    const cityName = sessionStorage.getItem('cityName');
    return (
        <header>
           
            <nav className="navbar">
            <div className='container'>
                <div className="navbar-content">
                    {/* <div className="desktop-menu"> */}
                        <div className="logo">
                            <Link to="/">
                                <img src={selsmartLogo} alt="Selsmart Logo" />
                            </Link>
                            
                        </div>
                       
                    {/* </div> */}
                </div>
                {/* Mobile Menu */}
                </div>
            </nav>
            
        </header>
    );
};

export default Header;
